import script from "./OrderMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderMenu.vue?vue&type=script&setup=true&lang=js"

import "./OrderMenu.vue?vue&type=style&index=0&id=1a37e6f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a37e6f2"]])

export default __exports__